import { Box, Link } from '@mui/material';
import BlockCarouselItemData from '../BlockCarouselItemData';
import { useGetBase64Image } from '../../../../hooks/UseGetBase64Image';

export interface CarouselItemProps {
  item: BlockCarouselItemData;
  handleOpen: () => void;
  maxHeight: number
}

function CarouselItem({
  item, handleOpen, maxHeight,
}: CarouselItemProps) {
  const backgroundImageBase64 = useGetBase64Image(item.image.value);

  return (
    <Box
      onClick={handleOpen}
      sx={{
        height: '100%',
        maxHeight: `${maxHeight}`,
        width: '100%',
        maxWidth: '100%',
      }}
    >
      {(item.link) ? (
        <Link
          sx={{
            width: '100%',
            height: '100%',
          }}
          href={item.link.linkData.url}
          target={item.link.linkData.openType}
          rel="noreferrer"
        >
          <div style={{
            backgroundImage: `url(${backgroundImageBase64})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '100%',
            height: '100%',
          }}
          />
        </Link>
      ) : (
        <div style={{
          backgroundImage: `url(${backgroundImageBase64})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          width: '100%',
          height: '100%',
        }}
        />
      )}
    </Box>
  );
}

export default CarouselItem;
